import React, { Component } from 'react'

class LinkedToggle extends Component {
  getValueFromPath (path) {
    var obj = this.props.context.state
    let stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }
  setValueAtPath (path, value) {
    let obj = this.props.context.state
    var current = obj
    let stack = path.split('.')
    while (stack.length > 1) {
      current = current[stack.shift()]
    }
    current[stack.shift()] = value
    return obj
  }
  constructor (props) {
    super(props)
    this.state = {
      value: this.getValueFromPath(this.props.path)
    }
  }
  componentWillReceiveProps (props) {
    if (this.state.value === this.getValueFromPath(this.props.path) && this.state.editable === props.editable) {
      return false
    }
    this.setState({
      value: this.getValueFromPath(this.props.path)
    })
  }
  handleChange (e) {
    this.props.context.setState(this.setValueAtPath(this.props.path, !this.getValue()))
    this.setState({
      value: !this.getValue()
    })
    this.props.context.forceUpdate()
    if (this.props.handleChange) this.props.handleChange()
  }
  getValue () {
    if (!this.state.value) {
      return false
    }
    if (this.state.value === true) {
      return true
    }
    if (typeof this.state.value === 'string' || this.state.value instanceof String) {
      let strValue = this.state.value.toLowerCase()
      if (strValue === 'true' || strValue === 'enable' || strValue === 'enabled' || strValue === 'on') {
        return true
      }
    }
    return false
  }
  render () {
    return (
      <div>
        <div onClick={(!this.props.disabled ? (e) => { this.handleChange(e) } : '')} className={(this.props.hidden ? 'hidden' : 'linked-toggle-wrapper') + (!this.getValue() ? ' linkedtoggle-disabled' : '') + ' ' + this.props.className + (this.props.button ? ' linked-toggle-wrapper-with-button' : '')}>
          <span>{this.props.name}</span>
          <div className={'linkedtoggle-indication ' + (this.getValue() ? 'lt-true' : 'lt-false')}>
            <i className={'fa fa-fw fa-' + (this.getValue() ? 'check-square-o' : 'square-o')} />
          </div>
        </div>
        {this.props.button && <button disabled={this.props.button.disabled}
          className={(this.props.button.hidden ? 'hidden' : 'btn btn-primary linkedinput-callback-button linkedtoggle-callback-button')}
          onClick={() => this.props.button.callback()}>
          <i className={'fa fa-fw ' + this.props.button.icon} />
        </button>}
      </div>
    )
  }
}
export default LinkedToggle



// WEBPACK FOOTER //
// ./src/components/basic/misc/LinkedToggle.js